module.exports = __webpack_public_path__ + "static/media/csv.8d2fd641.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/csv.svg
// module id = 1052
// module chunks = 3